// eslint-disable-next-line ferp-subgraph-ui/no-direct-mantine-import
import { Stack } from '@mantine/core';
import { PageHeader } from '../../components/PageHeader';
import { DataTable, type Column } from '../../components/DataTable';
import { StatusBadge } from '../../components/StatusBadge';
import { useKpis } from '../../hooks/useHr';

interface Kpi {
  id: string;
  name: string;
  description: string;
  kpiType: string;
  status: string;
}

interface KpisResponse {
  kpis: Kpi[];
}

const formatKpiType = (type: string) =>
  type
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export function KpiListPage() {
  const { data: queryData, loading } = useKpis();
  const kpisData = queryData as KpisResponse | undefined;
  const data = kpisData?.kpis ?? [];

  const columns: Column<Kpi>[] = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
    },
    {
      key: 'kpiType',
      label: 'Type',
      width: 120,
      render: (row) => formatKpiType(row.kpiType),
    },
    {
      key: 'description',
      label: 'Description',
      render: (row) =>
        row.description?.length > 80
          ? `${row.description.slice(0, 80)}...`
          : row.description || '-',
    },
    {
      key: 'status',
      label: 'Status',
      width: 120,
      render: (row) => <StatusBadge status={row.status} />,
    },
  ];

  return (
    <Stack gap="md">
      <PageHeader
        title="Key Performance Indicators"
        subtitle={`${data.length} KPIs`}
      />

      <DataTable<Record<string, unknown>>
        columns={columns as unknown as Column<Record<string, unknown>>[]}
        data={data as unknown as Record<string, unknown>[]}
        loading={loading}
        getRowKey={(row) => row.id as string}
        emptyMessage="No KPIs found"
      />
    </Stack>
  );
}

export default KpiListPage;
